import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=33a66004&scoped=true&"
import script from "./ProductDialog.vue?vue&type=script&lang=js&"
export * from "./ProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductDialog.vue?vue&type=style&index=0&id=33a66004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a66004",
  null
  
)

export default component.exports